<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import ThuxGenericComponentFilterMixin from '../../../components/thux-list/ThuxGenericComponentFilterMixin'
import { CommonFilterTypes } from '../store'

export default {
  name: 'RoleListFilter',
  mixins: [ThuxGenericComponentFilterMixin],
  data () {
    return {
      icon: 'fas fa-user-tag',
      itemName: 'role',
      itemPluralName: 'roles',
      placeholder: 'Type a role',
      filterName: 'filter__name__icontains',
      searchLength: 2
    }
  },
  computed: {
    ...mapGetters({
      list: CommonFilterTypes.COMMON_FILTERS.ROLE_COMMON_FILTER.LIST.GETTERS.list
    })
  },
  methods: {
    ...mapMutations({
      setList:
        CommonFilterTypes.COMMON_FILTERS.ROLE_COMMON_FILTER.LIST.MUTATIONS.setList
    }),
    ...mapActions({
      ...CommonFilterTypes.COMMON_FILTERS.ROLE_COMMON_FILTER.LIST.ACTIONS
    }),
    getComponentFilter () {
      this.setList({})
    }
  }
}
</script>
